import React from 'react'
import { PacienteEcuroInterface } from '../../ImportBackend/Interfaces/EcuroInterfaces'
import DataTable, { DataTableCabecalhoInterface } from '../../DevComponents/DataTable'
import ClsFormatacao from '../../Utils/ClsFormatacao'

interface PropsInterface {
    rsPacientesEcuro: Array<PacienteEcuroInterface>
    onSelecionarPaciente: (rs: PacienteEcuroInterface) => void
}

export default function PacientesCadastradosEcuroView({ rsPacientesEcuro, onSelecionarPaciente }: PropsInterface) {

    const onSelecionarLinha = (rs: PacienteEcuroInterface) => {
        if (rs.nome) {
            onSelecionarPaciente(rs)
        }
    }

    const Cabecalho: Array<DataTableCabecalhoInterface> = [
        {
            campo: 'cpf',
            cabecalho: 'CPF',
            alinhamento: 'left'
        },
        {
            campo: 'nome',
            cabecalho: 'Nome',
            alinhamento: 'left'
        },
        {
            campo: 'descricaoEcuroClinica',
            cabecalho: 'Clínica',
            alinhamento: 'left'
        },
        {
            campo: 'fone',
            cabecalho: 'Fone',
            alinhamento: 'left'
        },
        {
            campo: 'email',
            cabecalho: 'e-mail',
            alinhamento: 'left'
        },
        {
            campo: 'dataNascimento',
            cabecalho: 'Data de Nascimento',
            alinhamento: 'left',
            format: (v) => v ? (new ClsFormatacao()).dataISOtoUser(v) : 'Data Inválida'
        }
    ]

    return (
        <>
            <DataTable
                dados={rsPacientesEcuro}
                cabecalho={Cabecalho}
                // onSelecionarLinha={(rs) => onSelecionarLinha(rs as PacienteEcuroInterface)}
                acoes={[{ icone: 'content_paste_go', toolTip: 'Copiar Dados', onAcionador: onSelecionarLinha, onDisabled: (rs) => !rs.nome || !rs.dataNascimento || !rs.fone }]}
            />
        </>
    )


}